import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Checkbox from 'base/components/forms/Checkbox';
import theme from 'theme/index';
import { updatePermission } from 'auth/store/permissions/actions';
import { getInheritedPermissionsForObjectIdentityId } from 'auth/store/permissions/selectors';

class PermissionCheckbox extends Component {
  isGranting = () => {
    const { permissions, permission } = this.props;
    if (permissions && permission) {
      return permissions[permission];
    }
    return null;
  };

  handleClick = () => {
    const { readOnly } = this.props;
    if (readOnly) {
      return;
    }
    const {
      permissions, permission, updatePermission, objectIdentityId,
    } = this.props;
    updatePermission({
      ...permissions,
      // Always set oid, otherwise we might change the parent permissions
      // The inherited permission can only be changed at the parent
      objectIdentityId,
      [permission]: !permissions[permission],
    });
  };


  render() {
    const { permissions, readOnly } = this.props;
    const additionalProps = {};
    if (permissions && permissions.isInherited) {
      additionalProps.backgroundChecked = theme.colors.darker;
      additionalProps.backgroundIndeterminate = theme.colors.darker;
    }

    return (
      <Checkbox
        style={{ margin: '10px 15px' }}
        background={theme.colors.light}
        checked={this.isGranting()}
        onClick={this.handleClick}
        disabled={readOnly}
        {...additionalProps}
      />
    );
  }
}
PermissionCheckbox.propTypes = {
  updatePermission: PropTypes.func.isRequired,
  permissions: PropTypes.objectOf(PropTypes.any),
  permission: PropTypes.string,
  objectIdentityId: PropTypes.string,
  readOnly: PropTypes.bool,
};
PermissionCheckbox.defaultProps = {
  readOnly: false,
  permissions: null,
  permission: null,
  objectIdentityId: null,
};


const mapStateToProps = (state, props) => ({
  permissions: getInheritedPermissionsForObjectIdentityId(state, props.objectIdentityId),
});

const mapDispatchToProps = {
  updatePermission,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PermissionCheckbox);
